module.exports = __webpack_public_path__ + "img/verify-id.b784a7db.jpg";